import * as React from "react";

export class PageContent extends React.Component {
    render() {
        return (
            <div className="box-shadow p-3 p-md-4">
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/Layout.tsx